
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({
  components: {}
})
export default class TopBarSection extends Vue {
  @Prop({
    default: false
  })
  borderLeft!: boolean;

  @Prop({
    default: false
  })
  borderRight!: boolean;

  get classList() {
    const classList = ["topbar-section"];

    if (this.borderLeft) classList.push("topbar-section-bl");
    if (this.borderRight) classList.push("topbar-section-br");

    return classList;
  }
}
